@if (iSGetLottieOn) {
<div style="position: fixed; top: 50%; left: 50%; z-index: 1000; margin-top: -125px; margin-left: -150px">
  <!-- <ng-lottie
    width="300px"
    height="250px"
    containerClass="moving-box another-class"
    [options]="getAnimationOptions"
    >
  </ng-lottie> -->
</div>
}
<div class="dialog-container">
  @if (screenWidth > 480) {
  <div>
    <button type="button" class="close add-close-button" style="margin: auto" data-dismiss="modal" (click)="closedialog()">
      <span class="material-icons icons-close-mobile">close</span>
    </button>
  </div>
  } @if (screenWidth <= 480) {
  <div class="mobile-button">
    <button type="button" class="close add-close-button" style="margin: auto" data-dismiss="modal" (click)="closedialog()">
      <span class="material-icons icons-close-mobile">close</span>
    </button>
  </div>
  }
  <div style="display: flex; flex-direction: column" class="ask-security-key-main-container">
    <div style="text-align: center">
      <img src="../../../../../../assets/images/key-icon.png" class="ask-security-key-image" />
    </div>
    <div style="background-color: white; text-align: center">
      <p class="title-text">Premium Encryption Key Verification</p>
    </div>
    <div>
      <p class="sub-title-warning">
        {{
          data?.currentuserId == data?.currentValutUserId
            ? 'Please enter the Premium Encryption key in order to proceed'
            : 'Please enter the security key in order to proceed. You may need to ask the owner of this file to share it with you. '
        }}
      </p>
    </div>
    <form [formGroup]="documentForm" style="margin: 30px auto 0px auto; max-width: 90%; width: 360px">
      <mat-form-field
        appearance="fill"
        [ngClass]="!isClick ? 'automtic-form-desing-form-only' : 'automtic-form-desing-form-only-red'"
        style="width: 100% !important"
      >
        <mat-label class="automtic-form-desing-lable"> Enter Key </mat-label>
        <input maxlength="245" matInput style="font-size: 14px; color: #707070" formControlName="documentName" pattern="\d+" type="text" />
      </mat-form-field>
      <span style="min-height: 12px">
        @if (isClick) {
        <p style="color: red; position: relative; margin: 0px; user-select: auto; top: -18px">The entered key is not correct</p>
        }
      </span>
    </form>
    <div
      style="
        background-color: white;
        border-radius: 0px 0px 8px 8px;

        text-align: center;
        padding-bottom: 48px;
        padding-top: 16px;
      "
    >
      <div style="display: flex; flex-direction: column; max-width: 360px; margin: auto" class="hint-btn-container">
        @if (showHint &&currentuserId== data?.currentValutUserId && !data?.isRemoveEditSaveSharing && screenWidth <= 480) {
        <button class="hindt-button" (click)="ViewHint()">
          <mat-icon style="position: relative; top: 7px"> visibility </mat-icon>
          View Hint
        </button>
        } @if (screenWidth > 480) {
        <button
          (click)="Verify()"
          style="margin-bottom: 12px"
          [style.background]="!isClick ? '#2ECF99' : '#EB5757'"
          [class.disable-green-button-continue]="!documentForm.controls.documentName.value.length"
          class="button-try"
        >
          Verify
        </button>
        } @if (showHint && !data?.isRemoveEditSaveSharing && screenWidth > 480) {
        <button class="hindt-button" (click)="ViewHint()">
          <mat-icon style="position: relative; top: 7px"> visibility </mat-icon>
          View Hint
        </button>
        }
      </div>

      <div class="btn-mobile-container">
        @if (screenWidth <= 480) {
        <button
          (click)="Verify()"
          [style.background]="!isClick ? '#2ECF99' : '#EB5757'"
          [class.disable-green-button-continue]="!documentForm.controls.documentName.value.length"
          class="button-try-mobile"
        >
          Verify
        </button>
        }
      </div>
    </div>
  </div>
</div>
